<template>
	<div class="introduction_page">
		<div class="header">
			<img
				class="bg"
				src="https://cdncos.aigupiao.com/assets/pc/img/2023/tg2h.png"
			/>
			<div class="download_app_btn" @click="toDownloadApp">
				下载 爱股票APP
			</div>
		</div>


		<div class="content_wrap">
			<div class="slide_down_img"></div>
			<div class="introduction_item no_mt">
				<h3 class="introduction_item_titile">
				</h3>

				<div class="introduction_item_content">
					<div class="rank_info rank_info_1">轻松创建社群，移动端全渠道</div>
					<div class="introduction_item_text">

						<p>①本机号码一键登录</p>
						<p>
							②个性设置账号头像、昵称、背景图以及个人简介
						</p>
						<p>
							③可一键分享社群二维码名片，支持公众号微信群等多渠道分发
						</p>
						<p>④微信公众号 小程序 APP H5页等全渠道服务</p>
					</div>
					<div class="rank_info rank_info_2 rank_info_22">精品社群知识付费</div>
					<div class="introduction_item_text">
						<p>①支持多种内容输出形式：观点、长文、图片、直播</p>
						<p>②粉丝自助导入社群，无须手动拉人</p>
						<p>③可私信与粉丝在线沟通，更有在线直播与粉丝“面对面”互动</p>
						<p>④精品内容付费查看，流量变现更轻松</p>
						<p>⑤灵活定价，支持单篇文章付费</p>
						<p>⑥多样直播方式，视频、图文，与粉丝实时线上互动</p>
					</div>
					<div class="rank_info rank_info_3 rank_info_33">全工具链满足个性化服务需求</div>
					<div class="introduction_item_text">
						<p>平台拥有全球行情、龙虎榜、短线盯盘、财经资讯、公告研报、视频直播、聊天室等全套工具，满足个性化服务需求。</p>
					</div>
				</div>
			</div>

			<div class="introduction_item">
				<h3 class="introduction_item_titile tt2"></h3>
				<div class="introduction_item_content">
					<div class="rank_info rank_info_1">合法合规</div>
					<div class="introduction_item_text">
						<p>
							拥有证券期货牌照，可经营证券投顾业务
						</p>
						<p>运营流程完全符合证监会规定，合法合规，保证安全</p>
					</div>
					<div class="license_plate_wrap">
						<div class="license_plate_1">
							<div class="license_plate_1_bg">
								<img
									:src="
										'https://cdncos.aigupiao.com/assets/pc/img/2023/tg2i1.png'
									"
									:preview="randomStr"
								/>
							</div>
							<div class="license_plate_1_text">
								交易所行情授权
							</div>
						</div>
						<div class="license_plate_2">
							<div class="license_plate_2_bg">
								<img
									:src="
										'https://cdncos.aigupiao.com/assets/pc/img/2023/tg2i2.png'
									"
									:preview="randomStr"
								/>
							</div>
							<div class="license_plate_2_text">
								证券投资咨询牌照
							</div>
						</div>
					</div>
					<div class="rank_info rank_info_2">私域流量</div>
					<div class="introduction_item_text">
						<p>私域流量私密沟通，用户信息专享</p>
						<p>微信登陆，公众号绑定，自动生成推广链接</p>
					</div>
					<div class="introduce_wrap">
						<div class="introduce_3"></div>
					</div>
					<div class="rank_info rank_info_3">同步行情</div>
					<div class="introduction_item_text">
						<p>同步提供实时股票行情，24小时资讯速递，热点题材和龙虎榜分析，个股指导操作更直观</p>
					</div>
					<div class="introduce_wrap">
						<div class="introduce_4"></div>
					</div> 
					<div class="rank_info rank_info4">一键开播，上手即用</div>
					<div class="introduction_item_text">
						<p>课堂无延迟互动，赋能多场景，互动形式多样</p>
					</div>
					<div class="introduce_wrap">
						<div class="introduce_5"></div>
					</div>
				</div>
			</div>
			<div class="introduction_item">
				<h3 class="introduction_item_titile tt3"></h3>
				<div class="introduction_item_content">

					<div class="introduction_item_content_chose">
						<div class="introduction_item_chose" :class="[chose == 1 ? 'active' : '']" @click="chose = 1">APP申请方法</div>
						<div class="introduction_item_chose" :class="[chose == 2 ? 'active' : '']" @click="chose = 2">PC申请方法</div>
					</div>

					<div class="introduction_item_text_big p_t_5">
						{{ stepTextArr[stepIndex] }}
					</div>
					<div class="step_wrap">
						<div class="swiper-container" :class="'swiper-container'+chose">
							<div class="swiper-wrapper">
								<div
									class="swiper-slide"
									v-for="(item, i) in stepImgArr"
									:key="'ing_' + i"
								>
									<img class="swiper-img" :class="'swiper-img'+i" :src="item" />
								</div>
							</div>
						</div>
						<div class="swiper-pagination swiper-pagination_in"></div>
						<div class="slide_tip"></div>
					</div>
				</div>
			</div>
			<div class="introduction_item">
				<h3 class="introduction_item_titile tt4"></h3>
				<div class="introduction_item_content">
					<div class="introduction_item_text_big p_t_10">
						1.点击下载APP：
						<span @click="toDownloadApp" class="download_app_text">
							爱股票APP下载
						</span>
					</div>
					<div class="introduction_item_text_big p_t_8">
						2.手机扫描或者识别二维码：
					</div>
					<div class="introduce_wrap">
						<div class="download_app_code">
							<img
								:src="
									'https://cdncos.aigupiao.com/assets/pc/img/2023/tg2q3.svg'
								"
							/>
						</div>
					</div>
					<div class="introduction_item_text_big">
						3.百度搜索“爱股票”进入官网
					</div>
					<div class="introduction_item_text_big p_t_8 p_b_14">
						4.pc站输入网址：www.aigupiao.com
					</div>
				</div>
			</div>
			<div class="introduction_item">
				<h3 class="introduction_item_titile tt5"></h3>
				<div class="introduction_item_content">
					<div class="contact_us_text">
						<p>高手入驻、机构合作：</p>
					</div>
					<div class="introduce_wrap introduce_wrap_end1">
						<div class="personnel_code_wrap">
							<div class="personnel_code personnel_code_1">
								<img
									:src="
										'https://cdncos.aigupiao.com/assets/pc/img/2023/tg2q1.svg'
									"
								/>
							</div>
							<div class="personnel_code personnel_code_2">
								<img
									:src="
										'https://cdncos.aigupiao.com/assets/pc/img/2023/tg2q2.svg'
									"
								/>
							</div>
						</div>
						<p>微信扫码即可与我们联系</p>
					</div>
					<div class="introduce_end">
						<p>更多联系方式</p>
						<ul>
							<li class="icon_wechat">微信：<span>15075276927</span> 13683136367</li>
							<li class="icon_qq">QQ： <span>2536058531</span> 793480140</li>
							<li class="icon_tel">E-mail：<span>zst@aigupiao.com</span>
								<br><span style="opacity: 0;margin-right: 0;">E-mail：</span><span>wxw@aigupiao.com</span></li>
						</ul>

					</div>


				</div>
			</div>
		</div>
		<!-- <div class="footer"></div> -->
	</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import Api from "@/api/home/index.js";

export default {
	name: "introductionPage",
	components: {},
	data() {
		return {
			randomStr: Math.random()
				.toString(36)
				.slice(-4),
			chose:1,
			stepImgArr1:[
				"https://cdncos.aigupiao.com/assets/pc/img/2023/tg2s1.svg",
				"https://cdncos.aigupiao.com/assets/pc/img/2023/tg2s2.png",
				"https://cdncos.aigupiao.com/assets/pc/img/2023/tg2s3.png"
			],
			stepTextArr1: [
				"第一步：下载APP并注册登录（可一键登录）",
				"第二步：我的 - 申请认证入口",
				"第三步：填写资料并提交",
			],
			stepImgArr2:[
				"https://cdncos.aigupiao.com/assets/pc/img/2023/tg2s4.png",
				"https://cdncos.aigupiao.com/assets/pc/img/2023/tg2s5.png",
				"https://cdncos.aigupiao.com/assets/pc/img/2023/tg2s6.png"
			],
			stepTextArr2: [
				"第一步：打开爱股票网站，登录后点击申请认证",
				"第二步：选择申请类型",
				"第三步：填写资料并提交",
			],
			stepIndex: 0,
			downloadAppUrl:"https://app.aigupiao.com/igp_ml.php?v=1&name=apply",

		};
	},
	watch: {

	},
	created() {
		this.getShareInfo();
	},
	mounted() {
		var that = this;
		this.$nextTick(() => {
			var swiper1 = new Swiper(".swiper-container", {
				pagination: {
					el: ".swiper-pagination",
					clickable: true
				},
				on: {
					slideChangeTransitionEnd: function() {
						that.stepIndex = this.activeIndex;
						// alert(this.activeIndex); //切换结束时，告诉我现在是第几个slide
					}
				}
			});
		});

	},
	computed:{
		stepImgArr(){
			if(this.chose == 1){
				return this.stepImgArr1;
			}
			else{
				return this.stepImgArr2;
			}
		},
		stepTextArr(){
			if(this.chose == 1){
				return this.stepTextArr1;
			}
			else{
				return this.stepTextArr2;
			}
		},
	},
	methods: {
		toDownloadApp() {
			location.href = this.downloadAppUrl;
		},
		async getShareInfo() {
			let res = await Api.getShareInfo({
				page_type: 'introduction',
			});
			console.info(res,'res', res && res.status == 'success')
			if(res && res.share_title != '') {
				let data = res;
				let share_obj={
					share_open :data.share_open,
					share_logo : data.share_logo || "https://cdncos.aigupiao.com/assets/wap/img/logo80x80.png",
					share_link : data.share_link,
					share_content : data.share_content,
					share_title : data.share_title,
				}
				console.info(share_obj)
				this.$share(share_obj);
			}
    	},
	}
};
</script>

<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
.p_t_5 {
	padding-top: rem2(5px);
}
.p_t_10 {
	padding-top: rem2(10px);
}
.p_t_8 {
	padding-top: rem2(8px);
}

.p_b_14 {
	padding-bottom: rem2(14px);
}

.introduction_page {
	
	.header {
		position: relative;
		background: #DA1A20;
		> img.bg {
			width: 100%;
			height: auto;
			vertical-align: top;
		}
		.download_app_btn {
			position: absolute;
			width: 176.5px;
			height: 39.5px;
			flex-shrink: 0;
			left: 50%;
			transform: translateX(-50%);
			bottom: 45px;
			border-radius: 38.5px;
			background: linear-gradient(180deg, #FFFBF5 0%, #FFD59E 61.71%, #FFDAAB 100%);
			box-shadow: 0px 2px 11px 0px rgba(255, 169, 71, 0.13);
		
			color: #E71E24;
			font-weight: bold;
			font-size: 15px;
			display: flex;
			align-items: center;
			justify-content: center;
		
		}
	}


	.content_wrap {
		width: 100%;
		// height: rem2(4064px);
		padding: 0 rem2(17px) rem2(40px) rem2(17px);
		box-sizing: border-box;
		background: #DA1A20;
		margin-top: -.5px;

		.slide_down_img {
			width: 340px;
			height: 357.96px;
			margin: 0 0 30px;
			background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/tg2h2.png");
			background-repeat: no-repeat;
			background-size: 100%;
			background-position: center;
		}
		.introduction_item {
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-top: rem2(40px);
			&.no_mt {
				margin-top: 0;
			}
			.introduction_item_titile {
				width: 100%;
				height: 60px;
				flex-shrink: 0;
				background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/tg2tt1.png");
				background-repeat: no-repeat;
				background-size: 100%;
				vertical-align: top;

				&.tt2{
					background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/tg2tt2.png");
				}

				&.tt3{
					background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/tg2tt3.png");
				}

				&.tt4{
					background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/tg2tt4.png");
				}

				&.tt5{
					background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/tg2tt5.png");
				}

			}

			.introduction_item_content {
				width: 100%;
				border-radius: 0px 0px 16px 16px;
				background: #FFF;
				padding: 0 rem2(15px) rem2(10px) rem2(15px);
				box-sizing: border-box;
				margin-top: -0.5px;

				.introduction_item_content_chose{
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-bottom: 10px;
					.introduction_item_chose{
						display: flex;
						height: 36.621px;
						width: 148px;
						justify-content: center;
						align-items: center;
						border-radius: 6px;
						background: #F1F1F1;
						color: #9A5740;
						text-align: justify;
						font-size: 15px;
						font-style: normal;
						font-weight: 400;
						line-height: 21.5px; /* 143.333% */
						&.active{
							border-radius: 6px;
							background: #FFDFDA;
							font-weight: bold;
						}
					}
				}

				.contact_us_text{
					margin: rem2(6px) 0 rem2(20px);
				}

				.introduce_wrap_end{
					margin: rem2(23px) auto;
					width: 95%;
					padding-top: rem2(15px);
					border-top: rem2(0.5px) solid rgba(195,177,167,0.21);

					.img_bg{
						width: rem2(178.5px);
						height: rem2(178.5px);
						background: url(https://cdncos.aigupiao.com/assets/img/introduction/img_bg2.png);
						background-size: contain;
						margin: rem2(10px) auto;
						display: flex;
						align-items: center;
						justify-content: center;
						>img{
							width: rem2(139px);
							height: rem2(139px);
						}
					}
				}
				.introduction_brief {
					font-size: rem2(13px);
					color: #9a5740;
					line-height: rem2(20px);
					text-align: justify;

					padding: rem2(4px) 0 rem2(15px);
					.agq_name {
						font-size: rem2(17px);
						font-weight: bold;
					}
					.flow_realization {
						font-size: rem2(13px);
						font-weight: bold;
					}
				}

				.rank_info {
					height: rem2(50px);
					background-repeat: no-repeat;
					background-size: rem2(50px) rem2(50px);
					box-sizing: border-box;
					text-indent: rem2(30px);
					font-size: rem2(15px);
					color: #9a5740;
					line-height: rem2(22px);
					padding-top: rem2(20px);
					font-weight: bold;
					&.rank_info_1 {
						background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/icon_first@2x.png");
					}
					&.rank_info_2 {
						background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/icon_second@2x.png");
					}
					&.rank_info_3 {
						background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/icon_third@2x.png");
					}

					&.rank_info4 {
						background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/icon_4.png");
					}

					&.rank_info_22{
						margin-top: 30px;
					}

					&.rank_info_33{
						margin-top: 15px;
					}
				}
				.introduction_item_text {
					margin-top: rem2(5px);
					> p {
						font-size: rem2(13px);
						color: #9a5740;
						line-height: rem2(20px);
					}
				}
				.introduce_wrap {
					width: 100%;
					display: flex;
					justify-content: center;

					&.introduce_wrap_end1{
						width: 100%;
						height: 181px;
						flex-shrink: 0;
						border-radius: 17px;
						background: #FFF;
						box-shadow: 0px 0px 7px 0px rgba(179, 179, 179, 0.50);
						display: block;
						margin-top: rem2(5px);
						margin-bottom: rem2(12px);
						padding: 16px 22px;
						box-sizing: border-box;
						p{
							text-align: center;
							color: #9A5740;
							font-size: 13px;
							margin-top: 12px;
						}
					}
					.introduce_3 {
						width: 241.5px;
						height: 193.529px;
						flex-shrink: 0;
						margin-top: rem2(10px);
						margin-bottom: rem2(3px);
						background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/tg2im1.png");
						background-size: 100%;
						background-repeat: no-repeat;
					}
					.introduce_4 {
						width: 221.5px;
						height: 216px;
						flex-shrink: 0;
						margin-top: rem2(10px);
						margin-bottom: rem2(12px);
						background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/tg2im2.png");
						background-size: 100%;
						background-repeat: no-repeat;
					}

					.introduce_5 {
						width: 126px;
						height: 187.916px;
						flex-shrink: 0;
						margin-top: rem2(25px);
						margin-bottom: rem2(35px);
						background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/tg2im3.png");
						background-size: 100%;
						background-repeat: no-repeat;
					}
					.download_app_code {
						width: rem2(178px);
						height: rem2(178px);
						margin-top: rem2(5px);
						margin-bottom: rem2(12px);

						> img {
							width: 100%;
							height: 100%;
						}
					}
					.personnel_code_wrap {
						display: flex;
						justify-content: space-between;
						> .personnel_code {
							width: rem2(120px);
							height: rem2(120px);
							> img {
								width: 100%;
								height: 100%;
							}
						}
					}
				}
				.license_plate_wrap {
					width: 100%;
					display: flex;
					justify-content: space-between;
					margin-top: rem2(5px);
					margin-bottom: rem2(10px);
					.license_plate_1 {
						.license_plate_1_bg {
							width: rem2(118px);
							height: rem2(155px);

							> img {
								width: 100%;
								height: 100%;
							}
						}
						.license_plate_1_text {
							height: rem2(16px);
							font-size: rem2(12px);
							color: #9a5740;
							line-height: rem2(16px);
							text-align: center;
							margin-top: rem2(3px);
						}
					}
					.license_plate_2 {
						.license_plate_2_bg {
							width: rem2(180px);
							height: rem2(155px);
							> img {
								width: 100%;
								height: 100%;
							}
						}
						.license_plate_2_text {
							height: rem2(16px);
							font-size: rem2(12px);
							color: #9a5740;
							line-height: rem2(16px);
							text-align: center;
							margin-top: rem2(3px);
						}
					}
				}
				.introduction_item_text_big {
					min-height: rem2(22px);
					font-size: rem2(15px);
					color: #9a5740;
					line-height: rem2(22px);
					.download_app_text {
						text-decoration: underline;
					}
				}
				.contact_us_text {
					> p {
						height: rem2(22px);
						font-size: rem2(15px);
						color: #9a5740;
						line-height: rem2(22px);
						text-align: center;
					}
				}
				.step_wrap {
					width: 100%;

					margin-top: rem2(17px);
					.swiper-container {
						width: 100%;
						height: rem2(375px);
						border-radius: 6px;
						.swiper-slide{
							display: flex;
							align-items: center;
							justify-content: center;
							background: #FFDFDA;
						}
						
						
						.swiper-img {
							width: 80%;
							height: 80%;
						}

						&.swiper-container1{
							.swiper-img0 {
								width: 201.528px;
								height: 295.295px;
								flex-shrink: 0;
							}
							.swiper-img1 {
								width: 237.624px;
								height: 296.7px;
								flex-shrink: 0;
							}
							.swiper-img2 {
								width: 139.774px;
								height: 296.7px;
								flex-shrink: 0;
							}
						}
						&.swiper-container2{
							.swiper-img0 {
								width: 180.08px;
								height: 296.7px;
								flex-shrink: 0;
							}
							.swiper-img1 {
								width: 270px;
								height: 162.135px;
								flex-shrink: 0;
							}
							.swiper-img2 {
								width: 270px;
								height: 189.105px;
								flex-shrink: 0;
							}
						}
					}
					.swiper-pagination {
						position: static;
						height: rem2(36px);
						padding-top: rem2(15px);
						box-sizing: border-box;
					}
					.slide_tip {
						height: rem2(16px);
						background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/tg2ww.svg");
						background-size: rem2(131px) rem2(16px);
						background-repeat: no-repeat;
						background-position: center;
					}
				}
			}
		}
	}
	.footer {
		height: rem2(125px);
		background-color: #ff3131;
		background-image: url("https://cdncos.aigupiao.com/assets/img/introduction/footer_bg@2x.png");
		background-size: 100%;
		background-repeat: no-repeat;
		position: relative;
		top: rem2(-0.5px);
	}
}
.introduce_end {
	color: #9a5740;

	ul {
		display: flex;
		flex-wrap: wrap;
	}
	li {
		font-size: rem2(13px);
		flex: 0 0 100%;
		line-height: rem2(20px);
		margin-bottom: rem2(13px);
		padding-left: rem2(24px);
		box-sizing: border-box;
		white-space: nowrap;
		span{
			margin-right: rem2(20px);
		}
	}
	.icon_wechat {
		background: url("https://cdncos.aigupiao.com/assets/pc/img/2023/tg2ic1.svg") no-repeat left
			center / rem2(20px) rem2(20px);
	}
	.icon_qq {
		background: url("https://cdncos.aigupiao.com/assets/pc/img/2023/tg2ic2.svg") no-repeat left
			center / rem2(20px) rem2(20px);
	}
	.icon_tel {
		background: url("https://cdncos.aigupiao.com/assets/pc/img/2023/tg2ic3.svg") no-repeat
			left top / rem2(20px) rem2(20px);
	}

	>p{
		text-align: center;
		margin: rem2(18px) 0;
		font-size: rem2(15px);
	}

}

.introduce_warp_qr_code {
	display: flex;
	flex-wrap: nowrap;

	div {
		flex: 1;
		&:first-of-type {
			margin-right: 10px;
		}

		display: flex;
		justify-content: center;

		img {
			width: 70%;
			height: auto;
			display: block;
		}
	}
}
</style>
<style lang="scss">
@import "~@/assets/sass/global.scss";
//轮播图样式覆盖
.swiper-pagination.swiper-pagination_in {
	display: block;
	.swiper-pagination-bullet {
		width: rem2(16px);
		height: rem2(16px);
		margin-left: rem2(15px);
		outline: none;
		background-color: transparent;
		background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/icon_circle.svg");
		background-size: 100%;
		background-repeat: no-repeat;
		opacity: 1;
		box-sizing: border-box;
		background-position: center;
		&.swiper-pagination-bullet-active {
			background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/icon_circular.svg");
			background-size: 100%;
		}
	}
	.swiper-pagination-bullet:first-child {
		margin-left: 0;
	}
}
</style>
